"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Search/Refined/icons.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

// Round 3's stroke icons for the search window (24px grid). They draw in
// `currentColor`, so the colour comes from the token on the parent.






const makeIcon = (paths) => {
  const StrokeIcon = ({ size = 16, className }) => (
    _react2.default.createElement('svg', {
      className: className,
      width: size,
      height: size,
      viewBox: "0 0 24 24"   ,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.75",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      'aria-hidden': "true",
      focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}

      ,  paths 
    )
  )
  return StrokeIcon
}

 const SearchIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "11", cy: "11", r: "7", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}} )
  , _react2.default.createElement('path', { d: "M20 20l-3.5-3.5" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
)); exports.SearchIcon = SearchIcon

 const ChevronDownIcon = makeIcon(_react2.default.createElement('path', { d: "M6 9l6 6 6-6"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} )); exports.ChevronDownIcon = ChevronDownIcon
 const ChevronLeftIcon = makeIcon(_react2.default.createElement('path', { d: "M15 6l-6 6 6 6"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} )); exports.ChevronLeftIcon = ChevronLeftIcon
 const ChevronUpIcon = makeIcon(_react2.default.createElement('path', { d: "M6 15l6-6 6 6"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}} )); exports.ChevronUpIcon = ChevronUpIcon
 const CheckIcon = makeIcon(_react2.default.createElement('path', { d: "M5 12.5l4.5 4.5L19 7.5"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}} )); exports.CheckIcon = CheckIcon
 const CloseIcon = makeIcon(_react2.default.createElement('path', { d: "M6 6l12 12M18 6L6 18"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}} )); exports.CloseIcon = CloseIcon

 const ClockIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "9", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}} )
  , _react2.default.createElement('path', { d: "M12 7v5l3 2"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}} )
)); exports.ClockIcon = ClockIcon

 const CalendarIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "4", y: "5", width: "16", height: "15", rx: "2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}} )
  , _react2.default.createElement('path', { d: "M4 10h16M9 3v4M15 3v4"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}} )
)); exports.CalendarIcon = CalendarIcon

 const EmptySearchIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "11", cy: "11", r: "7", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}} )
  , _react2.default.createElement('path', { d: "M20 20l-3.5-3.5M8.5 11h5"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}} )
)); exports.EmptySearchIcon = EmptySearchIcon

 const EnterIcon = makeIcon(_react2.default.createElement('path', { d: "M19 6v5a3 3 0 01-3 3H6M9.5 10.5L6 14l3.5 3.5"        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}} )); exports.EnterIcon = EnterIcon
